import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { toolInput } from "../tool-input";

/** Slides-mode deck tools (docs/agents/slides-mode.md). */
export const slidesToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [HOST_TOOL_NAMES.DECK_LIST, () => labelOnly("Listed the decks")],
  [
    HOST_TOOL_NAMES.DECK_CREATE,
    (record) => {
      const title = toolInput.trimmed(record.title);
      return labelOnly(
        title ? `Created the deck “${title}”` : "Created a deck",
      );
    },
  ],
  [HOST_TOOL_NAMES.DECK_READ, () => labelOnly("Read the deck")],
  [
    HOST_TOOL_NAMES.DECK_WRITE_SLIDE,
    (record) =>
      labelOnly(
        toolInput.trimmed(record.slideId) ? "Rewrote a slide" : "Added a slide",
      ),
  ],
  [HOST_TOOL_NAMES.DECK_MOVE_SLIDE, () => labelOnly("Moved a slide")],
  [HOST_TOOL_NAMES.DECK_DELETE_SLIDE, () => labelOnly("Deleted a slide")],
  [HOST_TOOL_NAMES.DECK_RENDER, () => labelOnly("Rendered the deck")],
];
